import { surveyTrackingHasErrors } from './error';
import { fireEvent } from '../tag-commander/datalayer';
import { withAB } from '../../utils/ab/ab-utils';
import { AB_QUALTRICS_TMS } from '../../utils/ab/abs';

export const trackQualtricsViaTMS = (event: string) => {
  fireEvent({
    event_category: `survey_event:${event}`,
  });
};

export const trackQualtricsViaQsi = (event: string) => {
  try {
    const QSI = window.QSI;
    QSI.API.Events.push(event);
    QSI.API.unload();
    QSI.API.load().then(QSI.API.run);
  } catch (e) {
    return false;
  }
};

export const trackQualtrics = (event: string) => {
  if (!window || surveyTrackingHasErrors(event)) {
    return;
  }
  const trackingMethod = withAB(
    AB_QUALTRICS_TMS,
    trackQualtricsViaQsi,
    trackQualtricsViaTMS
  );
  return trackingMethod(event);
};
